/**
 * True when the request targets our own backend: a same-origin (relative) URL,
 * or an absolute URL under one of the configured API origins.
 * Use it to keep auth tokens and API-only headers away from third-party URLs.
 */
export function isApiRequest(url: string, apiOrigins: string[]): boolean {
    if (!/^https?:\/\//i.test(url)) {
        return true;
    }
    return apiOrigins.some((origin) => url.startsWith(origin));
}
